import { ApplicationInfoItem } from "../ApplicationInfoFieldItem/ApplicationInfoFieldItem";
import classes from "./ApplicationStatusBaseInfo.module.css";
import React from "react";
interface IApplicationStatusBaseInfoProps
  extends React.HTMLAttributes<HTMLDivElement> {
  status: React.ReactNode;
  appNumber: React.ReactNode;
}

export const ApplicationStatusBaseInfo = ({
  status,
  appNumber,
  className = "",
  ...restProps
}: IApplicationStatusBaseInfoProps) => {
  const concatClassName = `${className} ${classes.applicationStatusBaseInfo}`;
  return (
    <div {...restProps} className={concatClassName}>
      <ApplicationInfoItem label={"Номер заявки"} value={appNumber} />
      <ApplicationInfoItem label={"Cтатус"} value={status} />
    </div>
  );
};
